<template>
  <div class="floor-bg" :class="{ 'current-bg': currentFloorId == 201 }">
    <div
      class="floor-box"
      :class="{ current: currentFloorId == 201 }"
      @click="selectFloor()"
    >
      <div class="left-mengban"></div>
      <div class="right-mengban"></div>
      <el-scrollbar style="height: 100%; width: 100%">
        <div style="width: 100%">
          <ul class="tab-list">
            <li class="tab-li">
              <div class="tab current-tab">
                首页
                <img
                  src="../../../assets/images/m-decoration/current-tab-icon.png"
                  alt=""
                  class="tab-icon"
                />
              </div>
            </li>
            <li class="tab-li" v-for="(item, index) in tabList" :key="index">
              <div
                class="tab"
                :class="{
                  'current-tab': item.menuType == currentTab,
                }"
                :title="item.alias"
              >
                {{ item.alias }}
                <img
                  src="../../../assets/images/m-decoration/current-tab-icon.png"
                  alt=""
                  class="tab-icon"
                />
              </div>
            </li>
          </ul>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebMFloorTab",
  props: {
    currentFloorId: {
      type: Number,
    },
  },
  data() {
    return {
      currentTab: 0,
    };
  },
  computed: {
    tabList() {
      return this.$store.state.mDecoration.tabList;
    },
  },
  mounted() {},

  methods: {
    selectFloor() {
      this.$emit("selectFloor", {
        id: 201,
        index: -1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.floor-bg {
  &:hover {
    background: #f6f6f6;
    border-radius: 6px 6px 0 0;
  }
}
.current-bg {
  background: #f6f6f6;
  border-radius: 6px 6px 0 0;
}
.floor-box {
  position: relative;
  margin-top: 20px;
  background: linear-gradient(180deg, #ebf4fe 0%, #f6f6f6 100%);
  border-radius: 20px 20px 0 0;
  box-shadow: 0px 0px 5px 0px rgba(219, 219, 219, 0.1);
  cursor: pointer;
  &:hover {
    margin-left: -1px;
    margin-top: 19px;
    // padding: 7px 0 0px 0;
    border-radius: 6px;
    border: 1px dashed #197dff;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);
    .right-mengban {
      border-radius: 0px 6px 0 0;
      background: #fff;
    }
    .left-mengban {
      border-radius: 6px 0px 0 0;
      background: #fff;
    }
  }
  .left-mengban {
    position: absolute;
    left: 0px;
    top: 0px;
    z-index: 9;
    width: 20px;
    height: 44px;
    background: linear-gradient(180deg, #ebf4fe 0%, #f6f6f6 100%);
    border-radius: 20px 0px 0 0;
  }
  .right-mengban {
    position: absolute;
    right: 0px;
    top: 0px;
    z-index: 9;
    width: 30px;
    height: 44px;
    background: linear-gradient(180deg, #ebf4fe 0%, #f6f6f6 100%);
    border-radius: 0px 20px 0 0;
  }
  .tab-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 18px 20px;
    // width: auto;
    // width: 400px;
    .tab-li {
      padding: 0 11px;

      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 30px;
      }
      .tab {
        position: relative;
        color: #3a3d4b;
        font-size: 14px;
        line-height: 14px;
        // 不换行
        white-space: nowrap;
        .tab-icon {
          display: none;
          position: absolute;
          bottom: -9px;
          left: 50%;
          transform: translateX(-50%);
          width: 15px;
          height: 5px;
        }
      }
      .current-tab {
        color: #197dff;
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
        .tab-icon {
          display: block;
        }
      }
    }
  }
}
.current {
  margin-left: -1px;
  margin-top: 19px;
  // padding: 7px 0 0px 0;
  border-radius: 6px;
  border: 1px dashed #197dff;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(191, 191, 191, 0.25);
  .right-mengban {
    border-radius: 0px 6px 0 0;
    background: #fff;
  }
  .left-mengban {
    border-radius: 6px 0px 0 0;
    background: #fff;
  }
}
</style>
